import { Injectable, inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

/** Protect profile drafts before a route, outlet switch or logout changes context. */
@Injectable({ providedIn: 'root' })
export class OutletProfileSession {
  private leave: (() => Promise<boolean>) | null = null;
  register(leave: () => Promise<boolean>): () => void {
    this.leave = leave;
    return () => {
      if (this.leave === leave) this.leave = null;
    };
  }
  canLeave(): Promise<boolean> {
    return this.leave?.() ?? Promise.resolve(true);
  }
}
export const outletProfileGuard: CanDeactivateFn<unknown> = () =>
  inject(OutletProfileSession).canLeave();
